module.exports = __webpack_public_path__ + "media/images/pic/brodno/exam-0a645689ce42c9ea6f8584cd0cf6c088.svg";